import {
	TRADER_PROFILE_OPTIONS,
	UserSettings,
} from 'src/environmentVariables/EnvironmentVariables';

export const getCurrentTraderProfile = (
	currentSettings: Partial<UserSettings>
): 'custom' | 'default' => {
	if (
		currentSettings?.traderProfile === 'custom' ||
		currentSettings?.traderProfile === 'default'
	) {
		return currentSettings.traderProfile;
	}

	let currentProfile = 'custom';

	TRADER_PROFILE_OPTIONS.slice(0, -1).forEach((option) => {
		let match = true;
		Object.keys(option.value ?? {})
			.filter((settingKey) => settingKey !== 'traderProfile')
			.forEach((settingKey) => {
				if (
					option.value?.[settingKey as keyof UserSettings]?.toString() !=
					currentSettings[settingKey as keyof UserSettings]?.toString()
				) {
					match = false;
				}
			});

		if (match) {
			currentProfile = option.key;
		}
	});

	return currentProfile as 'custom' | 'default';
};

export const getInputPriceStepIncrement = (markPrice: number) => {
	if (markPrice < 0.01) return 0.00001;
	if (markPrice < 0.1) return 0.0001;
	if (markPrice < 1) return 0.001;
	if (markPrice < 10) return 0.01;
	if (markPrice < 100) return 0.1;
	if (markPrice < 1000) return 1;

	return 10;
};
